/*       */

import { gql } from '@apollo/client';
import entityDetailsCommonQuery from 'graphql/entities/common/entityDetailsCommonQuery';

export default gql`
    mutation deleteEntityMediaMutation(
        $type: String!,
        $id: ID!,
        $fileId: ID!,
        ) {
        result: deleteEntityMedia(
            type: $type,
            id: $id,
            fileId: $fileId){
            ${entityDetailsCommonQuery}
        }
    }
`;
